<template>
	<v-row v-if="!$store.getters.progress" style="height: max-content;" class="pb-offset">
		<v-col cols="12">
			<v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Invio multiplo preventivi</p>
                    <v-spacer></v-spacer>
                </v-card-title>         				
				<v-divider></v-divider>
				<v-container class="px-6" fluid>
					<v-row>
						<v-col cols="12" class="display-flex px-1 py-3">
							<strong>Preventivi Selezionati</strong>
							<span class="grey--text pr-4">&nbsp;({{ ids.length }})</span>

							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<div v-on="on" class="display-flex">
										<v-icon color="success" class="">mail</v-icon>
										<span class="grey--text pr-4">&nbsp;({{ countMailsCorrect }})</span>
									</div>
								</template>
								<span>Indirizzi corretti</span>
							</v-tooltip>
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<div v-on="on" class="display-flex">
										<v-icon color="error" class="">mail</v-icon>
										<span class="grey--text pr-4">&nbsp;({{ countMailsErrors }})</span>
									</div>
								</template>
								<span>Indirizzi mancanti</span>
							</v-tooltip>
						</v-col>
					</v-row>
				</v-container>
				<v-container class="pa-0 pt-2" fluid>

					<v-row class="pb-3">
						<v-col class="px-4 py-0" cols="12" sm="12" md="6" lg="4" v-for="(quotation, key, i) in model.quotations" :key="i">
							<v-list two-line class="background-2 w100p py-0">
								<v-list-item @click="$eventBusUtility.goTo($router, 'quotations', key)">
									<v-list-item-action>
										<v-icon :color="checkEmail(quotation.to) ? 'success' : 'error'">send</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>{{ quotation.subject }}</v-list-item-title>
										<v-list-item-subtitle>{{ quotation.to }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-col>
					</v-row>
				</v-container>

				<v-container class="pa-2 px-4" fluid>

					<v-row class="pb-3">
						<v-col class="px-4" cols="12">
							<small>Se l'indirizzo email risulta mancante il preventivo non verrà inviato.</small>
						</v-col>
						<v-col class="px-4" cols="12" lg="6">
							<v-combobox
								name="from"
								label="Da*"
								small-chips
								clearable
								required
								v-model="model['from']"
								:error-messages="errors.collect('Da')"
								v-validate="'email|required'"
								:data-vv-name="'Da'"
								outlined
								dense
							></v-combobox>
						</v-col>
						<v-col class="px-4" cols="12" lg="6">
							<v-combobox
								label="Nome Mittente*"
								small-chips                            
								clearable
								v-model="model['fromName']"
								color="primary"
								required
								:error-messages="errors.collect('Nome Mittente')"
								v-validate="'required'"
								:data-vv-name="'Nome Mittente'"
								outlined
								dense
							></v-combobox>
						</v-col>
						<v-col class="px-4" cols="12" lg="6">
							<v-text-field
								label="Oggetto*"
								v-model="model['subject']"
								type="text"
								ref="subject"
								required
								:error-messages="errors.collect('Oggetto')"
								v-validate="'required'"
								:data-vv-name="'Oggetto'"
								outlined
								dense
							></v-text-field>
						</v-col>
						<v-col class="px-4" cols="12" lg="6">
							<v-text-field
								label="Sconto aggiuntivo"
								hint="Questo sconto sarà aggiunto, se presente, allo sconto globale del preventivo"
								v-model="model['global_discount']"
								suffix="%"
								type="number"
								outlined
								dense
							></v-text-field>
						</v-col>

						<v-col class="px-4" cols="12" lg="6">
							<v-autocomplete
								:items="model['template_mail']"
								label="Template Mail"
								hint="Seleziona il template da inserite nella mail"
								:required="false"
								v-model="model['default_template']"
								return-object
								dense
								@change="setTemplateInTextEditor($event)"
								outlined
								>
							</v-autocomplete>
						</v-col>

						<v-col class="px-4" cols="12" lg="6">
							<v-autocomplete
								:items="signatures"
								label="Firma"
								hint="Seleziona una firma da inserite nella mail"
								:required="false"
								v-model="signatureSelected"
								dense
								return-object
								outlined
								>
							</v-autocomplete>
						</v-col>

						<v-col class="px-4 d-block" cols="12">
						<v-subheader class="pl-1 pt-2">Corpo</v-subheader>
							<tinymce-editor
								v-if="$store.getters.checkSettings('use_tinymce_editor')"
								editor-id="mail-text"
								v-model="model['body']"
								ref="tinymceEditor"
							/>
							<vue-editor v-else
								id="mail-text"
								v-model="model['body']"
								ref="editor"
							></vue-editor>
						</v-col>

						<v-col class="px-4 d-block text-center" cols="12">
							<template v-if="model.email_variables" >
								<v-chip v-for="(value, key, i) in model.email_variables.variables" outlined
								dense color="primary" text-color="primary" @click="setTemplateVariable(value)" :key="i" class="mx-1">
									{{ value }}
									<v-icon right>mdi-content-copy</v-icon>
									</v-chip>
							</template>
						</v-col>

					</v-row>
				</v-container>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" :loading="sent" text @click.native="validateFields()">Invia</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
		<confirm-dialog
		    :confirmModel="confirmSendMail"
		    mainTitle="Sei sicuro di inviare queste mail?"
		    secondTitle="Una volta premuto 'Invia' le mail saranno aggiunte a una coda di invio, potrai seguire il loro stato dai Mail Log e all'apertura del messaggio da parte del cliente riceverai una notifica"
		    @update:confirmModel="confirmSendMail = false"
		    :atConfirm="sendMails"
			:confirm="{color: 'info', label: 'invia'}"
		></confirm-dialog>
	</v-row>
</template>

<script>
	import MailTemplateMixin from '@/mixins/MailTemplateMixin'

	export default {
		name: "send-multiple-mails",
		mixins: [MailTemplateMixin],
		props: {
			selected: Array,
		},
		
		data() {
			return {
				model: {},
				url: 'info-send-multiple-mails/',
				styleClass: ['cols="12"', 'sm12', 'md6'],
				ids: [],
				sent: false,
				confirmSendMail: false,
				signatures: [],
				signatureSelected: '',
				signatureSeparator: '<br>--',
			}
		},

		created() {
			this.ids = []
			_.forEach(this.selected, (value, key) => {
				this.ids[key] = value.id
			})
			if(this.ids.length > 0) {
				localStorage.setItem('quotations_send_multiple_mails_ids', JSON.stringify(this.ids))
			} else {
				this.ids = JSON.parse(localStorage.getItem('quotations_send_multiple_mails_ids'))
			}


			this.axios.post('quotations-send-multiple-mails-info', {ids: this.ids}).then(response => {
				// get body data
				this.model = response.data.info
				this.model['default_template'] = response.data.info.default_template
				this.signatures = response.data.info.signatures
				if(typeof response.data.info.signature_default_id === 'undefined') {
				    this.signatureSelected = this.signatures[0]
				} else {
				    this.signatureSelected = response.data.info.signatures.filter((item) => {
				        return item.value == response.data.info.signature_default_id
				    })[0]
				}
				this.model['ids'] = this.ids
				this.$store.commit('endProgress')
			}, response => {
				// error callback
			});

		},
		
		methods: {
			checkEmail(email) {
				if(email === undefined || email == null || email === '') {
					return false
				} else {
					return true
				}
			},

			sendMails() {

				this.sent = true
				var form_data = new FormData();

				for ( var key in this.model ) {
					form_data.append(key, this.model[key]);
				}

				this.axios.post('quotations-send-multiple-mails', form_data).then(response => {
					// get body data
					this.sent = false
					//this.$store.commit('change')
					this.$router.go(-1)

				}, response => {
					// error callback
				});
			},
		},

		computed: {
			countMailsErrors() {
				if(this.model.quotations) {
					let count = 0
					_.forEach(this.model.quotations, (value, key) => {
						if(value.to === undefined || value.to == null || value.to === '') {
							count++
						}
					})
					return count
				} else {
					return 0
				}
			},

			countMailsCorrect() {
				return this.ids.length - this.countMailsErrors
			}
		},

	}
</script>
<style lang="css" scoped>
	div >>> .v-list-item {
		height: 58px;
	}
</style>